import { render } from "./CompositionChart.vue?vue&type=template&id=5661d444"
import script from "./CompositionChart.vue?vue&type=script&lang=js"
export * from "./CompositionChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__